import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";

import { listFormatter } from "@app/util/fieldModel/impl/fieldUtil";
import TerritoriesFilter, { TERRITORIES_FILTER_OPERATORS } from "@app/util/filters/Territories";

import Field, { FieldProperties } from "./Field";

class TerritoryField extends Field {
  constructor(data: Omit<FieldProperties, "type">) {
    super({
      customFilterConfig: {
        defaultInstance: "territories",
        disallowedConjunctions: ["OR"],
        filterInstances: {
          territories: TerritoriesFilter,
        },
        oneOccurrenceOnly: true,
        operators: [...TERRITORIES_FILTER_OPERATORS],
        topLevelOnly: true,
      },
      customGridProperties: {
        cellRenderer: "territoriesCellRenderer",
      },
      extraPlatformFiltersGetter: () => ({ includeTerritories: true }),
      features: [
        FieldFeature.TERRITORY_FIELD,
        FieldFeature.FILTERABLE,
        FieldFeature.FILTERABLE_ON_MAP,
        FieldFeature.SUPPORTS_SET_FILTER,
        FieldFeature.NON_IMPORT,
        FieldFeature.RELATIONSHIPS_CATEGORY,
        FieldFeature.NON_ADDABLE_FORM_FIELD,
      ],
      filterType: FieldType.ID,
      type: FieldType.LIST,
      valueFormatter: listFormatter("name"),
      ...data,
    });
  }
}

export default TerritoryField;
